// Import ticket status data for configuration
import ticketStatusData from "@/data/ticket-status.json";

// API Configuration
export const API_ENDPOINTS = {
  CREATE_TICKET: "/api/create-ticket",
  UPDATE_TICKET: "/api/update-ticket",
  GENERATE_IMAGE: "/api/generate-image",
  CREATE_CHECKOUT: "/api/create-checkout",
  STRIPE_WEBHOOK: "/api/stripe-webhook",
  MANUFACTURER_TICKET: "/api/manufacturer-ticket",
  CRON_NOTIFICATIONS: "/api/cron/ticket-notifications",
  SELLER_ONBOARD: "/api/seller/onboard",
  SELLER_COMPANY_PROFILE: "/api/seller/company-profile",
  SELLER_MANUFACTURER_REQUEST: "/api/seller/manufacturer-request",
  PAYOUT_TRIGGER: "/api/payout/trigger",
} as const;

// Stripe Configuration
const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;

export const STRIPE_ONBOARDING_REFRESH_URL = `${BASE_URL}/seller-onboarding?stripe_onboard=refresh`;
export const STRIPE_ONBOARDING_RETURN_URL = `${BASE_URL}/seller-onboarding?stripe_onboard=success`;

// Ticket Status Configuration
export const TICKET_STATUS = ticketStatusData.statuses;

export const TICKET_STATUS_LABELS = ticketStatusData.labels;

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: "Check your connection and try again.",
  AUTH_REQUIRED: "Authentication required",
  INVALID_INPUT: "Check your details and try again.",
  SERVER_ERROR: "We couldn't complete your request. Please try again.",
  RATE_LIMIT_EXCEEDED: "Too many requests. Please wait a moment and try again.",
  INSUFFICIENT_CREDITS:
    "You don’t have enough credits. Add credits to continue.",
  GENERATION_FAILED: "We couldn't create your preview. Please try again.",
  UPLOAD_FAILED: "We couldn't upload your file. Please try again.",
} as const;

// Upload preset defaults
export const DEFAULT_UPLOAD_PROMPT =
  "Put this dress on the dress stand, remove any humans, remove background, keep only the dress";

// Prompt to use in tickets for upload presets (front or back)
export const UPLOAD_TICKET_PROMPT = "Uploaded Image";

// UI Configuration
export const UI_CONFIG = {
  TOAST_DURATION: 4000,
  MODAL_TRANSITION_DURATION: 300,
  DEBOUNCE_DELAY: 500,
  PAGINATION_SIZE: 20,
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  SUPPORTED_IMAGE_TYPES: ["image/jpeg", "image/png", "image/webp"],
} as const;
